import React from "react";
import { createTheme } from "@mui/material/styles";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: "#556cd6",
      gray: "#B0B0B0",
      darkGray: "#5b626b",
      lightGray: "#eee",
      darkYellow: "#ffae00",
      green: "#6EAB3D",
      white: "#fff",
      black: "#000"
    },
    secondary: {
      main: "#19857b",
    },
    error: {
      main: "#dc3545",
    },
    success: {
      main: "#157347",
    },
  },
  typography: {
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
});

export default theme;
